import { render, staticRenderFns } from "./dbutton.vue?vue&type=template&id=53d43692&scoped=true"
import script from "./dbutton.vue?vue&type=script&lang=js"
export * from "./dbutton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d43692",
  null
  
)

export default component.exports